import React, { useState } from "react";
import Showdown from "showdown";
import "./Citations.css";

const Citations = ({ citations }) => {
  const [expanded, setExpanded] = useState([]);
  const converter = new Showdown.Converter();

  const toggleExpand = (index) => {
    setExpanded((prevExpanded) =>
      prevExpanded.includes(index)
        ? prevExpanded.filter((i) => i !== index)
        : [...prevExpanded, index]
    );
  };

  if (!citations || citations.length === 0) {
    return null;
  }

  return (
    <div className="citations">
      <h4 className="citation-header">Citations:</h4>
      {citations.map((citation, index) => (
        <div key={index} className="citation">
          <button
            onClick={() => toggleExpand(index)}
            className="citation-button"
          >
            {citation.title}
          </button>
          <div
            className={`citation-content ${
              expanded.includes(index) ? "show" : ""
            }`}
            dangerouslySetInnerHTML={{
              __html: expanded.includes(index) ? citation.content : "",
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default Citations;
